"use client";

import { useContext } from "react";
import { NotificationsContext } from "@/app/providers/NotificationsProvider";
import type { UseNotificationsReturn } from "./useNotifications.interface";
export const useNotifications = () => {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error("useNotifications must be used within a NotificationsProvider");
  }
  return context;
};